import React from 'react';
import { TabGroup as HeadlessTabGroup } from '@headlessui/react';
import { cn } from '../../utils/cn';

export const TabGroup = React.forwardRef<
  React.ElementRef<typeof HeadlessTabGroup>,
  React.ComponentPropsWithoutRef<typeof HeadlessTabGroup> & {
    className?: string;
  }
>(({ children, className, ...props }, ref) => (
  <HeadlessTabGroup ref={ref} className={cn('w-full', className)} {...props}>
    {children}
  </HeadlessTabGroup>
));

TabGroup.displayName = 'TabGroup';
